import React from 'react';

interface AttentionBadgeProps {
  count: number;
}

// Sprint 25, story-134. Red circular attention count, hidden entirely at 0 — a quiet sub reads
// as quiet, not as an empty badge.
export const AttentionBadge: React.FC<AttentionBadgeProps> = ({ count }) => {
  if (!count) return null;
  return (
    <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-xs font-semibold">
      {count}
    </span>
  );
};

export default AttentionBadge;
